import React from 'react'
import { Stack } from 'react-bootstrap'
import { SendCode } from './SendCode'
import { VerifyCode } from './VerifyCode'
import { ErrorDisplay } from './ErrorDisplay'

export const Layout = () => {
  return (
    <Stack gap={3}>
      <ErrorDisplay />

      <SendCode />
      <VerifyCode />
    </Stack>
  )
}
